const destinations = [
  {
    name: "Bahamas",
    context: "Nassau, Exumas, and Eleuthera are weekend destinations for Boca Raton yacht owners and charter clients. Crystal-clear waters 60 nautical miles from the Boca Inlet. All visitors require valid passports for Bahamian customs clearance",
    urgency: "Spontaneous Bahamas charters book 3–5 days out — document issues discovered at Boca Inlet are true emergencies",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Europe (River Cruises)",
    context: "Rhine, Danube, and Seine river cruises are the top international vacation choice for Boca Raton's affluent retiree and snowbird population. Viking, AmaWaterways, and Scenic embarkations in Amsterdam, Basel, and Paris",
    urgency: "River cruise deposits require passport details months before sailing — expiration issues discovered late cancel non-refundable bookings",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Cayman Islands",
    context: "Grand Cayman attracts Boca Raton's finance community for offshore banking, investment management meetings, and CIMA compliance visits. Private flights and charter connections from PBI and FLL",
    urgency: "Financial services compliance trips often confirm on short notice — passport validity is rarely the first thing checked",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Mediterranean",
    context: "Italy, Greece, Croatia, and Turkey draw Boca Raton's luxury travel market for private villa rentals, yacht charters, and premium cruise itineraries. High season is June through September",
    urgency: "Mediterranean yacht charter operators require passport copies before contract signing — often 3–4 months before charter dates",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Canada (Summer)",
    context: "Many Boca Raton snowbirds maintain summer properties in Ontario, Quebec, British Columbia, or Atlantic Canada. Cross-border travel by air requires a valid U.S. passport — passports managed between two residences sometimes fall through the cracks",
    urgency: "Snowbirds heading north in May discover expired passports that were stored at their Florida home during renewal time",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Israel & Mediterranean Jewish Heritage",
    context: "Boca Raton has one of the largest Jewish populations in Florida, with significant travel to Israel for religious tourism, heritage trips, family visits, and B'nai Mitzvah celebrations. El Al and direct charter flights from MIA",
    urgency: "Family celebration trips to Israel often confirm 4–8 weeks out — children and teens may need first-time passports",
    icon: "ri-map-pin-2-line",
  },
];

const stats = [
  { stat: "54%", label: "of Boca Raton expedited requests involve leisure travel, cruise departures, or yacht charter emergencies" },
  { stat: "3 Airports", label: "within 50 miles of Boca Raton — PBI, FLL, and MIA offer extensive international options" },
  { stat: "Oct–Apr", label: "peak snowbird season when Boca Raton's seasonal population surges and travel urgency increases" },
  { stat: "5 Days", label: "shortest yacht charter passport emergency we have accommodated for a Boca Raton Bahamas trip" },
];

export default function BocaDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Boca Raton Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From European river cruises and Bahamas yacht charters to Cayman financial meetings and Mediterranean villas, Boca Raton's affluent travel base operates on a premium timeline — and passport emergencies still happen, often when it's most inconvenient.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Florida Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Palm Beach, Broward, and Miami-Dade counties with the same expedited passport expertise.
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/delray-beach" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Delray Beach <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/fort-lauderdale" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Fort Lauderdale <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/miami" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Miami <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}